import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalService } from 'src/app/services/modal/modal.service';

interface AlertDialogButton {
  text: string;
  role: 'cancel' | 'confirm';
  action?: () => Observable<any>;
}
export interface AlertDialogData {
  image?: string;
  title: string;
  description: string;
  buttons: AlertDialogButton[];
}

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {

  @Input() data: AlertDialogData | undefined;
  showLoading = false;

  constructor(private modalService: ModalService) { }

  onClickButton(button: AlertDialogButton): void {
    if (button.action) {
      this.showLoading = true;
      button.action().subscribe(() => {
        this.close(button);
      }, error => {
        this.close(button);
      });
      return;
    }
    this.close(button);
    
  }
  close(button: AlertDialogButton): void {
    this.showLoading = false;
    switch (button.role) {
      case 'cancel':
        this.modalService.dismiss(false);
        return;
      case 'confirm':
        this.modalService.dismiss(true);
    }
  }
}
